export const HubTypes = {
	REGION: 1,
	HEALTHCARE: 2,
	THOUGHT_LEADERSHIP: 3,
	LIVE_EVENT: 4,
	PHARMA: 5,
	MED_TECH: 6,
	CRITICAL_ISSUES: 7,
	MANAGEMENT: 8,
	GLOBAL: 9,
	CONSUMER: 10,
	MED_TECH_SUB: 11,
	PHARMA_SUB: 12,
};

export const SpecialHubs = {
	LIVE_EVENT: 17,
};
